<template>
  <div class="dashboard container-fluid bg-white flex-grow-1">
    <div class="row flex-grow-1">
      <div class="col-md-12">
        <div
          class="
            dashboard__container
            h-100
            d-flex
            flex-column
            justify-content-center
            align-items-center
          "
        >
          <img src="../../../../assets/img/home.png" class="img-fluid" />
          <h4 class="text-center">
            {{ $t("Common.WelcomeDotCare") }}
          </h4>
        </div>

        <!--<P class="text-center"></P>-->
        <!--<button class="btn btn-primary btnStart">Start</button>-->
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "dashboard"
};
</script>


<style lang="scss" scoped>
.dashboard__container {
  min-height: calc(100vh - 170px);
  margin-bottom: 17px;
}
.dashboard h4 {
  text-align: center;
  margin-top: 24px;
  font-weight: 500;
}

.dashboard p {
  color: #888888;
}

/*.btnStart {
    background-color: #3CC8A2 !important;
    color:white !important;
    border:none !important;
    text-align:center !important;
    width:264px;
}*/
.dashboard {
  background-image: url("../../../../assets/img/home-pop.png");
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
  height: 650px;
}
</style>

